import React, { useState, useEffect } from 'react';

const InlineEdit = ({ value, onSave, className }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(value);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setText(value);
  }, [value]);

  const handleSave = async () => {
    if (!onSave || typeof onSave !== 'function') {
      console.warn('InlineEdit: onSave não é uma função válida');
      setIsEditing(false);
      return;
    }

    if (!text.trim() || text.trim() === value) {
      setText(value);
      setIsEditing(false);
      return;
    }

    try {
      setSaving(true);
      await onSave(text.trim());
      setIsEditing(false);
    } catch (error) {
      console.error('Erro ao salvar:', error);
      setText(value); // Reverte em caso de erro
      setIsEditing(false);
    } finally {
      setSaving(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      setText(value);
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <input
        type="text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        className={`${className} bg-white border border-blue-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500`}
        autoFocus
        disabled={saving}
        placeholder={saving ? 'Salvando...' : 'Digite o texto'}
      />
    );
  }

  return (
    <span
      onClick={() => setIsEditing(true)}
      className={`${className} cursor-pointer hover:bg-gray-100 rounded px-2 py-1 transition-colors`}
      title="Clique para editar"
    >
      {value || 'Clique para editar'}
    </span>
  );
};

export default InlineEdit;